module.exports = __webpack_public_path__ + "static/media/BackgroundCovid.fb013c41.png";